import styled from 'styled-components';
import { heading3 } from 'ui/theme';

const HeaderContent = styled.div`
  ${heading3}
`;

type Props = {
  children: React.ReactNode;
};

export const HeaderTitle = ({ children, ...props }: Props) => {
  return <HeaderContent {...props}>{children}</HeaderContent>;
};
